import { createContext } from 'react'

const KEY_SUBSCRIPTION_TYPE_FREE = 'free'

const SubscriptionContext = createContext({})

const SubscriptionProvider = SubscriptionContext.Provider

export default SubscriptionContext

export { SubscriptionProvider, KEY_SUBSCRIPTION_TYPE_FREE }
